<agpr-take-over-panel
    id="plainTextEditorDialog"
    class="agpr-plainTextEditor"
    header="Discover.distribution.plainTextEditor.dialog.header"
    [overlayContainer]="overlayContainer"
    [hideSlideOverlay]="hideSlideOverlay"
    [animationTrigger]="animationTrigger"
    (visibleChange)="handleVisibleChange($event)"
    [minPanelWidth]="600"
    [maxPanelWidth]="900"
    [responsiveWidth]="true"
>
    <p>{{ 'Discover.distribution.plainTextEditor.dialog.message' | localize }}</p>

    <agpr-message
        [severity]="messageSeverityEnum.warning"
        class="agpr-plainTextEditor-warningMessage"
    >
        <p>
            {{ 'Discover.distribution.plainTextEditor.dialog.regenerate.message' | localize }}
            <agpr-button
                [style]="buttonTypes.link"
                label="Discover.distribution.plainTextEditor.dialog.regenerate.button"
                (click)="regenerate()"
            ></agpr-button>.
        </p>
    </agpr-message>

    <agpr-textarea-input
        id="plainTextEditor.bodyText"
        class="agpr-plainTextEditor-bodyTextarea"
        [(ngModel)]="bodyPlainText"
        label="Discover.distribution.plainTextEditor.dialog.bodyTextarea"
        [placeholder]="'Discover.distribution.plainTextEditor.dialog.bodyTextarea.placeholder'"
        [bottomMargin]="false"
    ></agpr-textarea-input>

    <agpr-textarea-input
        id="plainTextEditor.footerPlainText"
        class="agpr-plainTextEditor-footerTextarea"
        [ngModel]="footerPlainText"
        [disabled]="true"
        label="Discover.distribution.plainTextEditor.dialog.footerTextarea"
        [tooltip]="'Discover.distribution.plainTextEditor.dialog.footerTextarea.tooltip'"
        [bottomMargin]="false"
    ></agpr-textarea-input>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="cancel"
            [style]="buttonTypes.secondary"
            (click)="close(actionTypesEnum.cancel)"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [style]="buttonTypes.primary"
            label="saveChanges"
            (click)="close(actionTypesEnum.save)"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
